import "./select.css";
import Select, { components } from "react-select";
import { useSelector } from "react-redux";

const CustomSelect = ({
  options,
  onChange,
  isMulti,
  components: customComponents,
  placeholder,
  value,
  isDisabled,
  label, // 👈 new prop
}) => {
  const isDarkMode = useSelector((state) => state.theme.darkMode);

  // Custom SingleValue to show "Label: Selected Option"
  const SingleValueWithLabel = ({ children, ...props }) => (
    <components.SingleValue {...props}>
      {label ? (
        <span>
          <span
            style={{
              color: isDarkMode ? "#a1a1aa" : "#71717a",
              fontWeight: 400,
              fontSize: "13px",
              marginRight: "4px",
            }}
          >
            {label}:
          </span>
          <span
            style={{
              color: isDarkMode ? "white" : "black",
              fontWeight: 500,
              fontSize: "13px",
            }}
          >
            {children}
          </span>
        </span>
      ) : (
        children
      )}
    </components.SingleValue>
  );

  const customStyles = {
    indicatorSeparator: () => ({ display: "none" }),
    control: (provided, state) => ({
      ...provided,
      backgroundColor: isDarkMode ? "#262626 !important" : "#F6F6F6 !important",
      boxShadow: state.isFocused ? "0 0 0 2px #3f3f46" : "none",
      border: isDarkMode ? "none !important" : "1px solid #e2e8f0 !important",
      borderRadius: "6px !important",
      height: "52px !important",
      position: "relative",
      fontStyle: "normal",
      fontSize: "12px !important",
      lineHeight: "18px !important",
      padding: "0px 16px !important",
      letterSpacing: "0.025em",
      "&:hover": {
        borderColor: isDarkMode ? "#3f3f46 !important" : "#F6F6F6 !important",
        cursor: "pointer",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? isDarkMode ? "#4D4D4D !important" : "#F6F6F6 !important"
        : state.isFocused
        ? isDarkMode ? "#4D4D4D !important" : "#F6F6F6 !important"
        : isDarkMode ? "#262626 !important" : "white !important",
      color: isDarkMode ? "white !important" : "black !important",
      cursor: "pointer !important",
      transition: "background-color 0.2s ease",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: isDarkMode ? "white !important" : "black !important",
      fontSize: "14px",
      fontWeight: "500",
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: isDarkMode ? "#262626 !important" : "#F6F6F6 !important",
    }),
    container: (provided) => ({
      ...provided,
      width: window.innerWidth <= 768 ? "90vw" : "250px",
    }),
  };

  return (
    <Select
      options={options}
      onChange={onChange}
      isMulti={isMulti}
      components={{
        SingleValue: SingleValueWithLabel, 
        ...customComponents,
      }}
      styles={customStyles}
      placeholder={placeholder}
      value={value}
      isDisabled={isDisabled}
      isSearchable={false}
    />
  );
};

export default CustomSelect;